<template>
  <div style="width: 100%; min-height: 100vh; background: #ffffff">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%;background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);
    z-index: 1000; color: white;" title="绑定支付宝" left-arrow @click-left="$router.back()" />
    <div style="height: 46px "></div>

    <!-- 真实姓名 -->
    <div class="usrse">
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">真实姓名</div>
        <div style="flex: 1; margin-left: 10px;">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_owner" placeholder="请输入真实姓名" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="font-size: 0.30rem; color: #3d72fa; text-align: center; box-sizing: border-box; padding: 6px">
      为了您的资金能够迅速到账，请确保填写的姓名与支付宝实名一致
    </div>

    <div class="usrse">
      <!-- 选择支付 -->
      <div class="hgs" @click="changShow" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">选择支付</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank" placeholder="请选择支付方式" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付宝账号 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">支付宝账号</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_no" placeholder="请输入支付宝账号" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 收款码上传 -->
      <div class="hgs" style="display: flex; align-items: flex-start; justify-content: space-between;">
        <div class="nams">收款码</div>
        <div style="flex: 1; margin-left: 10px;">
          <div style="display: flex; align-items: center;">
            <van-uploader
              :after-read="afterRead"
              :max-count="1"
              accept="image/*"
              style="display:inline-block;"
            >
              <div v-if="!cardInfo.bank_img" style="width: 90px; height: 90px; border: 1px dashed #d9d9d9; border-radius: 6px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #999;">
                <van-icon name="plus" size="24" />
                <span style="font-size: 12px; margin-top: 4px;">上传图片</span>
              </div>
            </van-uploader>

            <div v-if="cardInfo.bank_img" style="position: relative; margin-left: 10px;">
              <img :src="previewImg" alt="" style="width: 90px; height: 90px; object-fit: cover; border-radius: 6px; border: 1px solid #eee;" />
              <van-icon name="cross" @click="removeImg" style="position: absolute; top: -8px; right: -8px; background: #ee0a24; color: #fff; border-radius: 50%; padding: 2px; font-size: 12px; cursor: pointer;" />
            </div>
          </div>
          <div style="font-size: 12px; color: #999; margin-top: 6px;">请上传支付宝收款码，便于核对</div>
        </div>
      </div>

      <!-- 确认姓名 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">确认姓名</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="confirmName" placeholder="请再次输入真实姓名" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付密码 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">支付密码</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="cardInfo.pay_pass" type="password" placeholder="请输入支付密码" />
          </van-cell-group>
        </div>
      </div>

      <van-button type="info" style="margin-top: 20px; width: 100%" @click="bindCard">确认添加</van-button>
      <div style="height: 60px"></div>
    </div>

    <!-- 选择支付弹层 -->
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="选择支付方式" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'addAlipay',
  data() {
    return {
      cardInfo: {
        type: 4,
        bank_owner: '',
        bank: '',
        bank_no: '',
        bank_img: '',
        pay_pass: '',
      },
      confirmName: '',
      banklist: [],
      show: false,
    };
  },
  computed: {
    previewImg() {
      if (!this.cardInfo.bank_img) return '';
      if (this.cardInfo.bank_img.startsWith('http')) return this.cardInfo.bank_img;
      let base = process.env.VUE_APP_BASE_API || 'https://api.17mx.top';
      return base + this.cardInfo.bank_img;
    }
  },
  created() {
    this.getBanklist();
  },
  methods: {
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.cardInfo.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    getBanklist() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/banklist', { type: 4 })
        .then(res => {
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },

    afterRead(file) {
      let that = this;
      file.status = 'uploading';
      file.message = '上传中...';

      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('image', file.file);

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uploadimg', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(res => {
          that.$parent.hideLoading();
          if (res.code == 200) {
            let url = '';
            if (res.data && res.data.url) url = res.data.url;
            else if (res.url) url = res.url;
            else if (res.data && typeof res.data === 'string') url = res.data;

            if (url) {
              that.cardInfo.bank_img = url;
              file.status = 'done';
              that.$parent.showTost(1, '上传成功');
            } else {
              file.status = 'failed';
              that.$parent.showTost(0, '上传返回数据异常');
            }
          } else {
            file.status = 'failed';
            that.$parent.showTost(0, res.message || '上传失败');
          }
        })
        .catch(err => {
          that.$parent.hideLoading();
          file.status = 'failed';
          that.$parent.showTost(0, '上传失败');
        });
    },

    removeImg() {
      this.cardInfo.bank_img = '';
    },

    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入真实姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请选择支付方式');
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, '请输入支付宝账号');
        return;
      }
      if (!that.cardInfo.bank_img) {
        that.$parent.showTost(0, '请上传收款码');
        return;
      }
      if (!that.confirmName) {
        that.$parent.showTost(0, '请输入确认姓名');
        return;
      }
      if (that.confirmName !== that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '确认姓名与真实姓名不一致');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '支付密码长度为6-18位');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding: 6px 20px 0;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
  }
  .hgs {
    margin-top: 10px;
    margin-bottom: 15px;
    padding: 8px 0;
  }
}
[class*='van-hairline']:after {
  border: none;
}
</style>
<style>
.van-nav-bar__title { color: white !important; }
.van-icon-arrow-left { color: white !important; }
</style>


// WEBPACK FOOTER //
// src/components/addAlipay.vue